import {
  TabView as PrTabView,
  TabPanel as PrTabPanel,
  TabViewProps,
} from 'primereact/tabview';
import { ReactNode } from 'react';
import { twJoin, twMerge } from 'tailwind-merge';

const textSizeClassnames = {
  small: 'text-xs',
  medium: 'text-sm',
  large: 'text-base pt-5',
};
interface Props extends TabViewProps {
  size: `small` | `medium` | `large`;
  extended: boolean;
  tabData: {
    label: string;
    content: ReactNode;
    leftIcon?: ReactNode;
    RightIcon?: ReactNode;
  }[];
  navClassName: string;
  headerActionClassName: string;
  headerClassName: string;
  styleClass?: { wrapper: object };
  showDefaultBottomBorder: boolean;
}

export const Tabs = ({
  className,
  activeIndex = 0,
  onTabChange,
  tabData = [],
  size = 'medium',
  extended = false,
  headerActionClassName,
  headerClassName,
  navClassName,
  styleClass,
  showDefaultBottomBorder = true,
}: Props) => {
  return (
    <>
      {tabData.length > 0 ? (
        <PrTabView
          className={`${className}`}
          activeIndex={activeIndex}
          onTabChange={onTabChange}
          pt={{
            root: {
              className: 'w-full',
              ...(styleClass && { style: styleClass?.wrapper }),
            },
            nav: {
              className: twMerge(
                'p-0 w-fit xl:w-full flex justify-center',
                twJoin(navClassName && navClassName)
              ),
              style: {
                listStyleType: 'none',
              },
            },
            panelContainer: {
              className: 'p-0 h-full',
            },
          }}
        >
          {tabData.map((elem, index) => {
            return (
              <PrTabPanel
                header={elem.label}
                key={index}
                leftIcon={elem.leftIcon}
                rightIcon={elem.RightIcon}
                pt={{
                  root: { className: 'h-full' },
                  //@ts-ignore
                  header: ({ context }) => ({
                    className: `w-full ${extended ? `px` : `mx-4`} ${
                      context.index === activeIndex
                        ? `border-pv-primary-primary-500 border-b-2 text-pv-primary-primary-500`
                        : `${showDefaultBottomBorder ? `border-pv-neutral-grey-100 border-b` : ``}`
                    } ${headerClassName && headerClassName}`,
                    style: {
                      minWidth: 'fit-content',
                      marginTop: `${
                        context.index === activeIndex && '-1.25px'
                      }`,
                    },
                  }),
                  //@ts-ignore
                  headerAction: ({ context }) => ({
                    // className: `hover:no-underline focus:no-underline border-none px-5 py-4 hover:text-pv-primary-primary-500 flex items-center justify-center ${headerActionClassName && headerActionClassName} ${
                    //   textSizeClassnames[size]
                    // } ${
                    //   context.index === activeIndex
                    //     ? `text-pv-primary-primary-500 focus:text-pv-primary-primary-500 font-medium`
                    //     : `text-pv-text-secondary-text font-normal`
                    // }`,
                    className: twMerge(
                      'hover:no-underline focus:no-underline border-none px-5 py-4 hover:text-pv-primary-primary-500 flex items-center justify-center',
                      twJoin(
                        headerActionClassName && headerActionClassName,
                        context.index === activeIndex
                          ? `text-pv-primary-primary-500 focus:text-pv-primary-primary-500 font-medium`
                          : `text-pv-text-secondary-text font-normal`
                      ),
                      textSizeClassnames[size]
                    ),
                  }),
                }}
              >
                {elem.content}
              </PrTabPanel>
            );
          })}
        </PrTabView>
      ) : (
        <></>
      )}
    </>
  );
};
